class QuestionMultipleChoice extends BD_Question {
	constructor(...args) {
		super(...args);

		this.elms = {
			submit: ".js-submit",
			questionCard: ".questionCard",
			answer: ".js-answer",
		};
	}

	getAnswer(ctx) {
		return $(ctx.elms.answer.concat(":checked")).val();
	}

	getEvents() { 
		const elms = this.elms; 
		return [
			{
				event: "change",
				selector: elms.answer,
				handler: this.onSelectAnswer,
				isQuestionEvent: true
			},
		];
	}

	onSelectAnswer(e, $el) {
		$(this.elms.questionCard).find(".questionCard__actions").addClass("is-active");
	}
}
